
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatestafftransportpune() {



    const cardData =
    {
        keyword: 'Corporate Staff Transport Pune',
        heading: 'etravo : Corporate Staff Transport Pune',
        headingDescription: 'eTravo specializes in Corporate Staff Transport in Pune, offering end-to-end mobility solutions for businesses, IT parks, BPOs, and industrial zones. Our services include reliable daily pick-up and drop for employees, shift-based transport, and customized travel plans for corporate teams. With a modern fleet of AC cars, tempo travellers, and buses—equipped with GPS tracking and driven by trained chauffeurs—we ensure safe, punctual, and comfortable journeys. eTravo’s focus on operational efficiency and commuter satisfaction makes us the preferred choice for staff transportation services across Pune’s business districts.',

        top: 'Top Places to Visit in Pune with etravo',
         "topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Built in 1732 as the seat of the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fortification in Pune. Though much of it was destroyed in an 1828 fire, the surviving structures and gardens offer a glimpse into its grand past. The site is renowned for its architectural features and is a popular tourist attraction."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Constructed in 1892 by Sultan Muhammed Shah Aga Khan III, this palace played a significant role during India's freedom movement. It served as a prison for Mahatma Gandhi and his wife Kasturba Gandhi during the Quit India Movement. The palace now houses a museum and memorials dedicated to Gandhi and his associates."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located approximately 28 km southwest of Pune, Sinhagad Fort is a hill fortress known for the Battle of Sinhagad in 1670. The fort offers panoramic views and is a popular destination for trekking enthusiasts. It houses memorials and remnants of historical significance."
    },
    {
      "title": "Dagdusheth Halwai Ganapati Temple",
      "description": "This renowned temple is dedicated to Lord Ganesha and is famous for its rich history and the grand idol adorned with gold. It attracts thousands of devotees, especially during the Ganesh Chaturthi festival."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "An 8th-century rock-cut temple dedicated to Lord Shiva, the Pataleshwar Cave Temple is carved from a single basalt rock. The temple complex includes a circular Nandi mandapa and is a protected monument under the Archaeological Survey of India."
    },
    {
      "title": "Osho International Meditation Resort",
      "description": "Situated in Koregaon Park, this meditation center offers a tranquil environment for spiritual growth and wellness. It attracts visitors worldwide seeking meditation and personal development programs."
    },
    {
      "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
      "description": "Inspired by the 300-year-old Okayama Korakuen Garden in Japan, this beautifully landscaped garden symbolizes the Indo-Japanese friendship. It features manicured lawns, waterfalls, and a serene environment."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This museum houses an extensive collection of artifacts showcasing India's rich cultural heritage. Exhibits include musical instruments, sculptures, and everyday objects from the 18th and 19th centuries."
    },
    {
      "title": "Koregaon Park",
      "description": "A vibrant neighborhood known for its lush greenery, upscale eateries, and cultural hubs. Koregaon Park is a popular destination for dining, shopping, and experiencing Pune's cosmopolitan lifestyle."
    },
    {
      "title": "Lal Mahal",
      "description": "Originally built in the 17th century, Lal Mahal is historically significant as the childhood residence of Chhatrapati Shivaji Maharaj. The reconstructed palace now serves as a museum showcasing Maratha history."
    }
  ],



 "services": [
  {
    "name": "Corporate Staff Transport Pune",
    "description": "eTravo provides end-to-end corporate staff transport in Pune, catering to IT parks, industrial zones, and business hubs. Our tailored solutions include buses and cabs for smooth and timely employee commutes."
  },
  {
    "name": "Employee Commute Solutions Pune",
    "description": "Streamline daily travel with eTravo’s employee commute solutions in Pune. We offer scalable transportation using AC buses and cabs, ideal for small teams and large corporate setups alike."
  },
  {
    "name": "Staff Pickup and Drop Services Pune",
    "description": "Ensure punctuality with eTravo’s staff pickup and drop services in Pune. Our optimized routing and real-time tracking enhance the daily commute experience for employees across the city."
  },
  {
    "name": "AC Bus and Cab Services for Staff Pune",
    "description": "eTravo offers AC bus and cab services for staff in Pune, providing a comfortable commute even during extreme weather. Ideal for regular office shifts, project travel, and group staff movement."
  },
  {
    "name": "Reliable Corporate Staff Transport Pune",
    "description": "Choose eTravo for reliable corporate staff transport in Pune. With trained drivers and GPS-enabled vehicles, we ensure safe, timely, and efficient employee movement every day."
  },
  {
    "name": "Customized Staff Transport Plans Pune",
    "description": "eTravo creates customized staff transport plans in Pune based on company size, shift patterns, and location coverage. From fixed routes to dynamic scheduling, we adapt to your needs."
  },
  {
    "name": "Monthly Rentals for Staff Mobility Pune",
    "description": "Save on costs with eTravo’s monthly rentals for staff mobility in Pune. Our transparent pricing and flexible contracts make it easy to manage regular employee transport across departments."
  },
  {
    "name": "Executive Employee Commute Pune",
    "description": "Provide premium travel for your leadership with eTravo’s executive employee commute services in Pune. Our clean, comfortable cars with experienced chauffeurs ensure a professional experience."
  },
  {
    "name": "Affordable Corporate Transport Pune",
    "description": "eTravo delivers affordable corporate transport in Pune with a focus on quality, safety, and efficiency. Choose from cabs, AC buses, or executive vehicles to meet your business budget."
  },
  {
    "name": "End-to-End Mobility for Employees Pune",
    "description": "Get complete mobility management with eTravo’s end-to-end transport solutions for employees in Pune. From scheduling to tracking and support, we handle all aspects of staff travel."
  },
  {
    "name": "Shuttle Services for Companies Pune",
    "description": "eTravo’s shuttle services for companies in Pune are ideal for large-scale staff commutes. We operate dedicated routes and timings to serve major business zones and IT corridors efficiently."
  },
  {
    "name": "Business Cab Services for Staff Pune",
    "description": "eTravo offers business cab services for staff in Pune, providing reliable, comfortable, and punctual transportation for daily work commutes, meetings, and project site visits."
  },
  {
    "name": "Industrial Area Staff Commute Pune",
    "description": "eTravo specializes in industrial area staff commute services in Pune. We serve MIDC zones and manufacturing clusters with well-maintained cabs and buses for factory and warehouse workers."
  },
  {
    "name": "Corporate Bus Rentals Pune",
    "description": "Get scalable transportation with eTravo’s corporate bus rentals in Pune. Suitable for daily staff movement, events, or large gatherings, our buses ensure safety, comfort, and punctuality."
  },
  {
    "name": "On-Demand Staff Cabs Pune",
    "description": "Need flexibility? Use eTravo’s on-demand staff cabs in Pune for last-minute or irregular transport needs. Quick dispatch and real-time support ensure your staff travels without delay."
  }
],
"tableData": [
  ["Corporate Staff Transport Pune", "Employee Commute Solutions Pune"],
  ["Staff Pickup and Drop Services Pune", "AC Bus and Cab Services for Staff Pune"],
  ["Reliable Corporate Staff Transport Pune", "Customized Staff Transport Plans Pune"],
  ["Monthly Rentals for Staff Mobility Pune", "Executive Employee Commute Pune"],
  ["Affordable Corporate Transport Pune", "End-to-End Mobility for Employees Pune"],
  ["Shuttle Services for Companies Pune", "Business Cab Services for Staff Pune"],
  ["Industrial Area Staff Commute Pune", "Corporate Bus Rentals Pune"],
  ["On-Demand Staff Cabs Pune", ""]
],






"whychoose": [
    {
        "WhyChooseheading": "Dependable Corporate Staff Transport in Pune",
        "WhyChoosedescription": "Pune’s fast-paced corporate environment demands reliable employee mobility. eTravo offers professional staff transport services that ensure your team reaches work and returns home safely, punctually, and comfortably—every day."
    },
    {
        "WhyChooseheading": "Fleet Options Tailored for Corporate Commutes",
        "WhyChoosedescription": "Our Pune fleet includes hatchbacks, sedans, MUVs, tempo travellers, and AC buses—ideal for transporting small teams or large workforces. We customize vehicle types based on your headcount, route, and shift timing."
    },
    {
        "WhyChooseheading": "Shift-Compatible and 24/7 Availability",
        "WhyChoosedescription": "Many businesses in Pune, especially in Hinjewadi, Magarpatta, and Kharadi, operate on shift patterns. eTravo provides round-the-clock staff transport services that adapt to your company’s specific scheduling needs."
    },
    {
        "WhyChooseheading": "Trained Drivers with Route Familiarity",
        "WhyChoosedescription": "Our professional drivers are background-verified, uniformed, and well-versed in Pune’s traffic patterns and major office zones. Their knowledge ensures safer, more efficient staff movement across the city."
    },
    {
        "WhyChooseheading": "Corporate Packages and Scalable Solutions",
        "WhyChoosedescription": "Whether you’re managing 20 or 200 employees, eTravo designs scalable transport packages to suit your operational scope. Our services grow with your organization—perfect for expanding teams and new branch setups."
    },
    {
        "WhyChooseheading": "Transparent Pricing and Admin-Friendly Billing",
        "WhyChoosedescription": "Our billing system offers clarity and convenience—no hidden costs, GST-compliant invoices, and monthly reports tailored for HR and finance teams to easily manage transport budgets."
    },
    {
        "WhyChooseheading": "Clean, Safe, and Well-Maintained Vehicles",
        "WhyChoosedescription": "Every vehicle undergoes regular maintenance and cleaning. GPS tracking, seat belts, fire extinguishers, and first aid kits are standard to ensure maximum safety and hygiene for your staff."
    },
    {
        "WhyChooseheading": "Live Ride Tracking and 24/7 Coordination",
        "WhyChoosedescription": "Track all staff rides in real time, and access our 24/7 support team for instant assistance. We coordinate directly with your HR and admin departments to ensure hassle-free and uninterrupted transport operations."
    }
]















    }

const faqData = [
    [
        {
            question: 'What corporate staff transport services does eTravo offer in Pune?',
            answer: 'eTravo offers end-to-end corporate staff transport in Pune, covering daily employee pick-up and drop, shift-based transport, and large-scale workforce mobility for IT parks and industrial zones.',
        },
        {
            question: 'Can eTravo handle transport for multiple shifts in Pune?',
            answer: 'Yes, eTravo specializes in multi-shift staff transport in Pune with dynamic route planning, time-slot management, and real-time tracking to ensure efficiency and reliability.',
        },
        {
            question: 'What fleet options are available for staff transport in Pune?',
            answer: 'Our Pune fleet includes hatchbacks, sedans, SUVs, tempo travellers, and AC buses ranging from 13 to 50 seaters, catering to both small teams and large workforces.',
        },
        {
            question: 'Does eTravo include safety and tracking features for staff transport?',
            answer: 'Absolutely. All staff transport vehicles are GPS-enabled, monitored in real time, and come with verified drivers, digital trip logs, and strict route compliance for safety.',
        },
        {
            question: 'Is there dedicated account management for staff transport in Pune?',
            answer: 'Yes, every corporate client receives a dedicated account manager to coordinate routes, manage daily operations, handle escalations, and deliver periodic performance reports.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Rajesh Nair',
        designation: 'Admin Lead, VisionTech Pvt. Ltd., Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo has streamlined our staff transport across Pune. The buses are always on schedule, and their support team is quick to respond. A professional and reliable service.”',
    },
    {
        name: 'Ms. Anuja Salvi',
        designation: 'HR Manager, PrimeWave Solutions, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“We’ve been using eTravo for staff transport for over a year. The routing is efficient, vehicles are clean, and employees feel safe. Highly recommended for corporate mobility in Pune.”',
    },
];














    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Staff Transport Pune",
  "image": "https://www.etravo.in/images/keyword/corporate-staff-transport-pune.jpg",
  "description": "Reliable corporate staff transport services in Pune including employee commute solutions, AC bus and cab services, customized staff transport plans, and monthly rentals for seamless employee mobility.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6009"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-staff-transport-pune"
  }
};





    return (
        <div>


<Helmet>
  <title>Corporate Staff Transport Pune | Employee Commute & Shuttle Services | eTravo</title>
  <meta 
    name="description" 
    content="Efficient corporate staff transport in Pune by eTravo. Employee commute, AC bus & cab services, customized transport plans, and monthly rentals for reliable staff mobility." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/12.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatestafftransportpune;